export enum AuditResultsStatus {
  NotSubmitted = 1,
  Approved = 2,
  ErrorReported = 3,
}

